import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { DeleteAbteilungCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [DeleteAbteilungCommandService],
  exports: []
})
export class DeleteAbteilungCommandServiceModule { }
